import { MessageService } from '../../../../services/message-service/message.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternTierarzt } from '../extern-tierarzt';
import { StammdatenService } from '../../stammdaten.service';

@Component({
    selector: 'kiene-extern-tierarzt-anlegen-dialog',
    templateUrl: './extern-tierarzt-anlegen-dialog.component.html',
    styleUrls: ['./extern-tierarzt-anlegen-dialog.component.scss'],
})
export class ExternTierarztAnlegenDialogComponent implements OnInit {
    nameCtrl = new FormControl(undefined, [Validators.required]);
    strasseCtrl = new FormControl();
    plzCtrl = new FormControl();
    ortCtrl = new FormControl();
    emailCtrl = new FormControl(undefined, [Validators.email]);
    telefonCtrl = new FormControl();
    faxCtrl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<ExternTierarztAnlegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public tierarzt: ExternTierarzt,
        private messageService: MessageService,
        private stammdatenService: StammdatenService,
    ) {}

    ngOnInit(): void {
        this.nameCtrl.setValue(this.tierarzt?.name);
        this.strasseCtrl.setValue(this.tierarzt?.strasse);
        this.plzCtrl.setValue(this.tierarzt?.plz);
        this.ortCtrl.setValue(this.tierarzt?.ort);
        this.emailCtrl.setValue(this.tierarzt?.email);
        this.telefonCtrl.setValue(this.tierarzt?.telefon);
        this.faxCtrl.setValue(this.tierarzt?.fax);
    }

    anlegen(): void {
        const tierarzt = new ExternTierarzt();
        tierarzt.name = this.nameCtrl.value;
        tierarzt.strasse = this.strasseCtrl.value;
        tierarzt.plz = this.plzCtrl.value;
        tierarzt.ort = this.ortCtrl.value;
        tierarzt.email = this.emailCtrl.value;
        tierarzt.telefon = this.telefonCtrl.value;
        tierarzt.fax = this.faxCtrl.value;

        this.stammdatenService.createOrUpdateExternTierarzt(tierarzt).subscribe({
            next: (response: ExternTierarzt) => {
                this.dialogRef.close(response);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Anlegen eines Tierarztes!', err);
            },
        });
    }
}
